<template>
    <!-- Warrning This is NOT CHILD of tabs component -->
    <!-- This requires immediate availability of tab for chart to render on it.
    v-show is thus too late (higher initial render cost) -->
    <div class="tab-pane" :class="{'active' : active}" v-if="active">
        <slot />
    </div>
</template>

<script>
export default {
    props : {

        label : {
            type : String,
            required : true,
        }

    },

    data() {
        return {
            active : false,
        };
    },

    methods : {

/* Since this isn't child component of tabs.
We can only connect throught presence/absence of certain methods.
This is ugly but only way completelly unrelated components will communicate */

        activate() {
            this.active = true;
        },

        deactivate() {
            this.active = false;
        },

        /* LoadingSpinned is 1st component of tabs.
        Since it doesn't have this method it can be filtered
        by checking of this method's definition's existence. */
        isTab() {
            return true;
        },

        getLabel() {
            return this.label;
        }

    }

};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/common/BootstrapTab.vue